import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReasonState } from './reason.reducer';

export const selectReasonState = createFeatureSelector<ReasonState>('reason');

export const selectReasons = createSelector(
  selectReasonState,
  (state) => state ? state.reasons : null
);
